var React = require('react');

function LonerX (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M85.7152 31.2036L71.3965 8.87117L46.9238 24.5554L31.2482 0.116089L8.92789 14.3958L24.6503 38.8819L0.177612 54.5661L14.4963 76.8986L38.9222 61.2144L54.6447 85.6537L76.9181 71.374L61.2425 46.8879L85.7152 31.2036Z","fill":"#C1BEAC"}));
}

LonerX.defaultProps = {"width":"86","height":"86","viewBox":"0 0 86 86","fill":"none"};

module.exports = LonerX;

LonerX.default = LonerX;
